namespace RioERP.Reports {
    export interface OrderSaleReportRow {
        Id?: number;
        OrderId?: number;
        OrderDate?: string;
        CustomerName?: string;
        CustomerMobile1?: string;
        CustomerEmail1?: string;
        City?: string;
        Address1?: string;
        Address2?: string;
        StateName?: string;
        PinCode?: string;
        Products?: string;
        TransactionId?: string;
        PaymentStatus?: Web.Enums.PaymentStatus;
        DiscountCode?: string;
        PaymentMode?: Web.Enums.PaymentMode;
        PaymentDate?: string;
        InvoiceNumber?: string;
        Gstin?: string;
        Currencies?: string;
        SourceType?: Web.Enums.SourceType;
        AffiliateId?: string;
        TaxableAmount?: number;
        Total?: number;
        DiscountAmount?: number;
        NetAmount?: number;
        TaxableAmountNet?: number;
        CgstRate?: number;
        CgstAmount?: number;
        SgstRate?: number;
        SgstAmount?: number;
        IgstRate?: number;
        IgstAmount?: number;
        TotalTax?: number;
    }

    export namespace OrderSaleReportRow {
        export const idProperty = 'Id';
        export const nameProperty = 'CustomerName';
        export const localTextPrefix = 'Reports.OrderSaleReport';
        export const deletePermission = 'Reports:ReportsManagement:Modify';
        export const insertPermission = 'Reports:ReportsManagement:Modify';
        export const readPermission = 'Reports:ReportsManagement:View';
        export const updatePermission = 'Reports:ReportsManagement:Modify';

        export declare const enum Fields {
            Id = "Id",
            OrderId = "OrderId",
            OrderDate = "OrderDate",
            CustomerName = "CustomerName",
            CustomerMobile1 = "CustomerMobile1",
            CustomerEmail1 = "CustomerEmail1",
            City = "City",
            Address1 = "Address1",
            Address2 = "Address2",
            StateName = "StateName",
            PinCode = "PinCode",
            Products = "Products",
            TransactionId = "TransactionId",
            PaymentStatus = "PaymentStatus",
            DiscountCode = "DiscountCode",
            PaymentMode = "PaymentMode",
            PaymentDate = "PaymentDate",
            InvoiceNumber = "InvoiceNumber",
            Gstin = "Gstin",
            Currencies = "Currencies",
            SourceType = "SourceType",
            AffiliateId = "AffiliateId",
            TaxableAmount = "TaxableAmount",
            Total = "Total",
            DiscountAmount = "DiscountAmount",
            NetAmount = "NetAmount",
            TaxableAmountNet = "TaxableAmountNet",
            CgstRate = "CgstRate",
            CgstAmount = "CgstAmount",
            SgstRate = "SgstRate",
            SgstAmount = "SgstAmount",
            IgstRate = "IgstRate",
            IgstAmount = "IgstAmount",
            TotalTax = "TotalTax"
        }
    }
}
